import { render, staticRenderFns } from "./DisplayLayoutEditor.vue?vue&type=template&id=44010313&scoped=true"
import script from "./DisplayLayoutEditor.vue?vue&type=script&lang=js"
export * from "./DisplayLayoutEditor.vue?vue&type=script&lang=js"
import style0 from "./DisplayLayoutEditor.vue?vue&type=style&index=0&id=44010313&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44010313",
  null
  
)

export default component.exports